<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex lg12 md12 xl12 xs12>
          <v-card>
            <v-card-title primary-title>
              <h3 class="headline mb-0">Teilnehmer ({{ participantCount }})</h3>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="participants"
                    :rows-per-page-items="[20]"
            >
              <template v-slot:items="props">
                <td>{{ props.item.startNumber }}</td>
                <td>{{ props.item.firstname }}</td>
                <td>{{ props.item.lastname }}</td>
                <td>{{ props.item.city }}</td>
                <td>{{ displayCategoryTitle(props.item.category) }}</td>
                <td>{{ props.item.duration }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import EventService from '../services/EventService'

  export default {
    computed: {
      participantCount() {
        return this.participants.length
      }
    },
    methods: {
      displayCategoryTitle (id) {
        return this.categories.find(category => category.id === id).title
      }
    },
    data: function () {
      return {
        event: {
          title: ''
        },
        categories: [],
        participants: [],
        headers: [
          {
            text: 'Starnummer',
            value: 'startNumber',
            aling: 'right'
          },
          {
            text: 'Vorname',
            value: 'firstname'
          },
          {
            text: 'Nachname',
            value: 'lastname'
          },
          {
            text: 'Ort',
            value: 'city'
          },
          {
            text: 'Kategorie',
            value: 'category'
          },
          {
            text: 'Dauer',
            value: 'duration'
          }
        ]
      }
    },
    created () {
      EventService.getEvent(this.$route.params.token).then(data => {
        this.event = data
      })
      EventService.getEventCategories(this.$route.params.token).then(data => {
        this.categories = data
      })
      EventService.getEventParticipants(this.$route.params.token, this.$route.params.password).then(data => {
        this.participants = data
      })
    }
  }
</script>
